import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type {
  IApiGetPollResultsQueryBody,
  IApiGetPollResultsResponseBody,
} from '../PollsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUsePollResultsQueryValues = {
  appId: string;
  pollId: string;
  body?: IApiGetPollResultsQueryBody;
};

export const pollResultsQueryKeyFactory: IQueryKeyFactory<
  IUsePollResultsQueryValues
> = (values) =>
  values &&
  (values.body
    ? (['pollResults', values.appId, values.pollId, values.body] as const)
    : (['pollResults', values.appId, values.pollId] as const));

export const usePollResultsQuery = (
  values?: IUsePollResultsQueryValues,
  options?: UseQueryOptions<IApiGetPollResultsResponseBody, ApiError>,
): UseQueryResult<IApiGetPollResultsResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: pollResultsQueryKeyFactory(values),
    queryFn: values
      ? () => api.polls.getResults(values.appId, values.pollId, values.body)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
